/* (ignored) */


//////////////////
// WEBPACK FOOTER
// canvas (ignored)
// module id = 710
// module chunks = 0